import Raven from 'raven-js';
import getStaticRev from '@loggi/js/get-static-rev';
import getDocument from '@loggi/js/get-document';
import logError from '@loggi/js/log-error';
import omit from 'lodash/omit';
import { defaultMiddlewareOptions, getOptions } from './config';

function createMiddleware(options = defaultMiddlewareOptions) {
  return store => next => action => {
    if (
      !options.breadcrumbBlacklist.includes(action.type) ||
      !options.breadcrumbBlacklist.length
    ) {
      Raven.captureBreadcrumb({
        category: 'redux-action',
        message: action.type,
        data: action
      });
    }

    const state = store.getState();
    let ravenState = options.extraContextBlacklist.reduce(
      (reduceState, blacklist) => omit(reduceState, blacklist),
      state
    );

    if (options.currentScreen) {
      ravenState.currentScreen = options.currentScreen;
    }

    Raven.setExtraContext(ravenState);

    next(action);
  };
}

function setRavenContextTags() {
  const staticRev = getStaticRev();
  if (staticRev !== null) {
    Raven.setRelease(staticRev);
    Raven.setTagsContext({ staticRev: staticRev });
  }
}

function setUserContext(user = null) {
  if (user) {
    Raven.setUserContext({
      email: user.email,
      id: user.pk
    });
  } else {
    Raven.setUserContext();
  }
}

function logException(ex, context) {
  Raven.captureException(ex, {
    extra: context
  });

  logError(ex);
}

export function install(dsn, user = null, configOptions = null) {
  if (!__DEV__) {
    Raven.config(dsn, getOptions(configOptions)).install();

    // Set static-rev
    if (navigator.product !== 'ReactNative') {
      const document = getDocument();
      if (document) {
        document.addEventListener('DOMContentLoaded', setRavenContextTags);
        setRavenContextTags();
      }
    }

    // Set user when available
    if (user !== null) {
      setUserContext(user);
    }
  }
}

function setExtra(extra) {
  Raven.setExtraContext(extra);
}

function captureMessage(message, context) {
  Raven.captureMessage(message, context);
}

export default {
  captureMessage,
  logException,
  install,
  createMiddleware,
  setUserContext,
  setExtra
};
